import {useEffect} from "react";

export const DEFAULT_FAVICON_HREF = "/favicon.png";

/**
 * Points the document's single `<link rel="icon">` (shipped in index.html) at the page's custom
 * favicon, falling back to the Uptime default.
 *
 * The icon is deliberately not rendered through Helmet. Helmet appends its own tag next to the
 * static one, and Chrome then has two sizeless candidates: it downloads the custom icon, moves on
 * to the default because a sizeless candidate is always "possibly better", and serves the default
 * from its favicon cache without ever comparing the two. The custom icon only shows after a reload
 * expires that cache. Mutating the one existing tag keeps Chrome's candidate list to a single entry.
 */
export const useFavicon = (href: string | null | undefined) => {
  useEffect(() => {
    const link = document.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) return;
    link.href = href || DEFAULT_FAVICON_HREF;
  }, [href]);
};
